import { listenForServiceWorkerMessages } from "~/utilities/pwa"

export default defineNuxtPlugin(() => {
  listenForServiceWorkerMessages()
})
